var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNfFaq = function SvgNfFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    fill: "none",
    viewBox: "0 0 81 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.26 50c11.19 0 20.26-8.954 20.26-20s-9.07-20-20.26-20C29.07 10 20 18.954 20 30s9.07 20 20.26 20z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE07D",
    d: "M31.755 20.7h8.893c1.888 0 3.418 1.53 3.418 3.418v4.438c0 1.888-1.53 3.418-3.418 3.418h-4.469L34.04 34.42c-.634.725-1.829.276-1.829-.687v-1.758h-.456c-1.888 0-3.418-1.53-3.418-3.418v-4.438c0-1.888 1.53-3.418 3.418-3.418z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD064",
    d: "M34 34.462c-.644.662-1.789.212-1.789-.731v-1.757h-.456c-1.888 0-3.418-1.53-3.418-3.418v-4.44c0-1.887 1.53-3.417 3.418-3.417h1.492c-1.888 0-3.418 1.53-3.418 3.418v4.439c0 1.887 1.53 3.418 3.418 3.418h.457v1.757c0 .3.116.551.295.731z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3E59F",
    d: "M47.245 26.224h-8.893c-1.888 0-3.418 1.53-3.418 3.418v4.439c0 1.888 1.53 3.418 3.418 3.418h4.468l2.14 2.444c.634.725 1.828.277 1.828-.687V37.5h.457c1.887 0 3.418-1.53 3.418-3.418v-4.439c0-1.887-1.53-3.418-3.418-3.418z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95D6A4",
    d: "M39.976 37.5h-1.624c-1.888 0-3.418-1.531-3.418-3.419v-4.439c0-1.887 1.53-3.418 3.418-3.418h1.624c-1.887 0-3.418 1.53-3.418 3.418v4.439c0 1.888 1.53 3.418 3.418 3.418z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M50.663 32.023c.186 0 .337-.151.337-.337v-2.044c0-2.07-1.684-3.755-3.755-3.755h-2.842v-1.77c0-2.07-1.685-3.755-3.755-3.755H33.92c-.186 0-.337.15-.337.337 0 .186.151.337.337.337h6.727c1.699 0 3.08 1.382 3.08 3.08v1.771h-5.376c-2.07 0-3.755 1.685-3.755 3.755v3.628l-.81.926c-.238.272-.56.28-.78.196-.222-.083-.459-.3-.459-.661v-1.757c0-.186-.15-.337-.337-.337h-.456c-1.699 0-3.081-1.382-3.081-3.081v-4.44c0-1.698 1.382-3.08 3.081-3.08h.819c.186 0 .336-.151.336-.337 0-.186-.15-.337-.336-.337h-.819c-2.07 0-3.755 1.684-3.755 3.755v4.439c0 2.07 1.684 3.755 3.755 3.755h.12v1.42c0 .58.35 1.087.894 1.292.161.06.327.09.491.09.389 0 .765-.166 1.034-.473l.31-.354c.106 1.976 1.747 3.55 3.748 3.55h4.316l2.038 2.33c.27.307.645.472 1.034.472.164 0 .33-.03.491-.09.543-.204.895-.711.895-1.292v-1.42h.119c2.07 0 3.755-1.684 3.755-3.755v-1.048c0-.186-.15-.337-.337-.337-.186 0-.337.151-.337.337v1.048c0 1.699-1.382 3.081-3.081 3.081h-.456c-.187 0-.337.151-.337.337v1.757c0 .36-.237.578-.458.661-.222.084-.543.076-.78-.196l-2.14-2.444c-.063-.073-.156-.115-.253-.115h-4.469c-1.699 0-3.08-1.382-3.08-3.081v-4.439c0-1.699 1.381-3.081 3.08-3.081h8.893c1.699 0 3.081 1.382 3.081 3.081v2.044c0 .186.151.337.337.337z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.901 29.776c-.067-.163-.225-.269-.399-.267-.176 0-.332.105-.399.268l-.003.007-1.562 4.103c-.066.174.02.369.195.435.173.066.368-.021.434-.195l.307-.805h2.046l.303.804c.05.135.179.218.315.218.04 0 .08-.007.119-.022.174-.066.262-.26.196-.434l-1.548-4.103-.004-.009zm-1.17 2.872l.77-2.024.764 2.024h-1.534zM39.085 30.237c.186 0 .337-.15.337-.337 0-.186-.15-.337-.337-.337h-1.674c-.186 0-.337.151-.337.337v4.13c0 .187.151.338.337.338.186 0 .337-.151.337-.337v-1.768h1.204c.186 0 .337-.15.337-.337 0-.186-.15-.337-.337-.337h-1.204v-1.352h1.337zM46.09 29.548c-1.334 0-2.418 1.084-2.418 2.417 0 1.333 1.084 2.418 2.417 2.418.554 0 1.065-.188 1.473-.502l.386.386c.066.066.152.1.238.1s.173-.034.238-.1c.132-.131.132-.344 0-.476l-.39-.39c.297-.402.473-.899.473-1.436 0-1.333-1.085-2.417-2.418-2.417zm0 4.161c-.962 0-1.744-.782-1.744-1.744 0-.961.782-1.743 1.743-1.743.962 0 1.744.782 1.744 1.743 0 .351-.104.678-.283.951l-.457-.456c-.132-.132-.345-.132-.476 0-.132.131-.132.345 0 .476l.463.463c-.282.195-.623.31-.99.31z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H23V23H0z",
    transform: "translate(28 19)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    width: 80.521,
    height: 80,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.803922 0 0 0 0 0.803922 0 0 0 0 0.803922 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
export default SvgNfFaq;